import styled from 'styled-components';

export const StyledValuesBarTooltip = styled.div`
  padding: 1rem;
`;
export const StyledTooltipItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem 0rem;
`;

export const StyledValuesBarItem = styled.div`
  background-color: ${props => (props.color ? props.color : '#EBEEF5')};
  width: ${props => (props.value ? `${props.value}%` : 0)};
  height: 1.5rem;
`;
export const StyledValuesBar = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  &.roundedView {
    & ${StyledValuesBarItem} {
      &:first-child {
        border-radius: 10px 0 0 10px;
      }
      &:last-child {
        border-radius: 0 10px 10px 0;
      }
    }
  }
`;
